import { createClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";
import { environment } from "./environment";

export const supabase = createClient<Database>(
  environment.VITE_SUPABASE_URL,
  environment.VITE_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      detectSessionInUrl: true,
      persistSession: true,
      storageKey: `jarasna-crm-auth-${environment.VITE_APP_ENV}`,
    },
  },
);
